import { Button, ButtonGroup, Col, ControlLabel, Form, FormGroup, Row, Well } from 'react-bootstrap';
import { ICenterBase } from '@nkr/models/index';

interface IProps {
    isAdmin: boolean,
    isLiverCenterView: boolean,
    centerId: number,
    includeDash: boolean,
    includeDcn: boolean,
    includeNkr: boolean,
    centerList: ICenterBase[],
    onChange: (property: string) => void,
    onFilter: () => void
    onExport: () => void
}

const Filter = (props: IProps) => {
    const handleIncludeChange = (e: React.FormEvent<HTMLButtonElement>) => {
        props.onChange(e.currentTarget.value);
    };

    return (
        <>
            <Well bsSize='sm'>
                <Form horizontal>
                    <Row>
                        <Col xs={12} lg={4}>
                            <FormGroup style={{ marginBottom: 0 }}>
                                <Col xs={3} componentClass={ControlLabel}>&nbsp;</Col>
                                <Col xs={9}>
                                    <ButtonGroup>
                                        <button type='button' className={"btn " + (props.includeDash ? 'btn-primary active' : 'btn-default')} value='includeDash' onClick={handleIncludeChange}>DASH</button>
                                        {!props.isLiverCenterView && <button type='button' className={"btn " + (props.includeDcn ? 'btn-primary active' : 'btn-default')} value='includeDcn' onClick={handleIncludeChange}>DCN</button>}
                                        <button type='button' className={"btn " + (props.includeNkr ? 'btn-primary active' : 'btn-default')} value='includeNkr' onClick={handleIncludeChange}>{props.isLiverCenterView ? 'NLR' : 'NKR'}</button>
                                    </ButtonGroup>
                                </Col>
                            </FormGroup>
                        </Col>

                        <Col xs={12} lg={4}>
                        </Col>

                        <Col xs={12} lg={3}>
                            <Button bsStyle='primary' style={{ width: '100%' }} onClick={props.onFilter}>Filter</Button>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Button bsStyle='warning' style={{ width: '100%' }} onClick={props.onExport}>CSV</Button>
                        </Col>
                    </Row>
                </Form>
            </Well>
        </>
    );
}

export default Filter;

